/* Fovory bag page (sections/fovory-bag.liquid).
   Every change goes to the Shopify cart API with this section in "sections", and the section is
   swapped for the fresh render: quantities, remove (with Undo), save for later (favourites, with Undo),
   change size, discount code, saved-for-later list, "Goes with your bag", deal countdown and the
   checkout bar on phone and tablet. */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fill = (s, o) => String(s || '').replace(/\[(\w)\]/g, (m, k) => (o[k] != null ? o[k] : m));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const base = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const root = () => $('[data-fv-bagp]');
  const sid = () => { const r = root(); return r ? r.dataset.sectionId : ''; };
  const icon = {
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    undo: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12a8 8 0 1 0 2.3-5.6"/><path d="M4 4v4.5h4.5"/></svg>'
  };

  let T = {};
  function readStrings() {
    const el = $('[data-fv-bagp-i18n]');
    if (!el) return;
    try { T = JSON.parse(el.textContent); } catch (e) { T = {}; }
  }
  function money(c) {
    const f = (window.MinimogSettings && MinimogSettings.money_format) || '€{{amount_with_comma_separator}}';
    if (typeof window.formatMoney === 'function') { try { return window.formatMoney(c, f); } catch (e) { /* fall through */ } }
    return (c / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------------- Saved-for-later memory (which size was in the bag) ---------------- */
  const SAVED_KEY = 'fv-saved-variants';
  function savedMap() { try { return JSON.parse(localStorage.getItem(SAVED_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function setSaved(h, v) {
    const m = savedMap();
    if (v) m[h] = v; else delete m[h];
    try { localStorage.setItem(SAVED_KEY, JSON.stringify(m)); } catch (e) { /* ignore */ }
  }
  const W = () => (window.MinimogTheme && MinimogTheme.Wishlist) || null;
  function favs() {
    const w = W();
    if (w && Array.isArray(w.products)) return w.products.slice();
    try { return JSON.parse(localStorage.getItem('m-wishlist-products') || '[]'); } catch (e) { return []; }
  }
  function addFav(h) {
    const w = W();
    if (w) { w.addToWishlist(h); if (w.updateWishlistCount) w.updateWishlistCount(); return; }
    const a = favs(); if (!a.includes(h)) { a.push(h); try { localStorage.setItem('m-wishlist-products', JSON.stringify(a)); } catch (e) { /* ignore */ } }
  }
  function removeFav(h) {
    const w = W();
    if (w) { w.removeFromWishlist(h); if (w.updateWishlistCount) w.updateWishlistCount(); return; }
    try { localStorage.setItem('m-wishlist-products', JSON.stringify(favs().filter((x) => x !== h))); } catch (e) { /* ignore */ }
  }

  /* ---------------- Cart requests ---------------- */
  function sections() {
    const list = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: list } }));
    if (!list.includes(sid())) list.push(sid());
    if (!list.includes('cart-count')) list.push('cart-count');
    return Array.from(new Set(list.filter(Boolean)));
  }
  async function post(path, body) {
    const r = await fetch(`${base()}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(Object.assign({}, body, { sections: sections().join(','), sections_url: location.pathname }))
    });
    const j = await r.json();
    if (j.status && j.status !== 200) throw new Error(j.description || j.message || T.error);
    return j;
  }
  function publish(j) {
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: j });
    } else if (j.sections && j.sections[sid()]) {
      render(j.sections[sid()]);
    }
  }
  function busy(el, on) { if (el) el.classList.toggle('is-busy', !!on); }
  function toast(el, msg) {
    const host = el || root();
    if (!host) return;
    let p = $('.fv-bagp__err', host);
    if (!p) {
      p = document.createElement('p');
      p.className = 'fv-code__err fv-bagp__err';
      p.setAttribute('role', 'alert');
      host.appendChild(p);
    }
    p.textContent = msg || T.error;
  }

  /* ---------------- Render ---------------- */
  function render(html) {
    const cur = root();
    if (!cur || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = $('[data-fv-bagp]', doc);
    if (!next) return;
    cur.replaceWith(next);
    paint();
  }

  /* ---------------- Undo ---------------- */
  let undo = null;
  function paintUndo() {
    if (!undo) return;
    if (Date.now() - undo.t > 30000) { undo = null; return; }
    const r = root();
    const row = document.createElement('div');
    row.className = 'fv-bi-undo';
    row.setAttribute('role', 'status');
    const txt = fill(undo.kind === 'saved' ? T.savedMsg : T.removed, { t: '\u0000' }).split('\u0000');
    row.innerHTML = `<span>${esc(txt[0])}<b>${esc(undo.title)}</b>${esc(txt[1] || '')}</span><button type="button" data-fv-undo>${icon.undo}${esc(T.undo)}</button>`;
    const list = $('[data-fv-items]', r);
    if (list) {
      const kids = list.children;
      if (undo.index < kids.length) list.insertBefore(row, kids[undo.index]); else list.appendChild(row);
    } else {
      const crumbs = $('.fv-crumbs', r);
      if (crumbs) crumbs.after(row); else r.prepend(row);
    }
  }

  /* ---------------- Deal countdown ---------------- */
  function tick() {
    const now = Math.floor(Date.now() / 1000);
    $$('[data-fv-end]', root() || document).forEach((el) => {
      const s = parseInt(el.dataset.fvEnd, 10) - now;
      if (s <= 0) { const pill = el.closest('.fv-sum__deal'); if (pill) pill.hidden = true; return; }
      const p = (n) => String(n).padStart(2, '0');
      const d = Math.floor(s / 86400);
      el.textContent = (d > 0 ? d + (T.d || 'd') + ' ' : '') + p(Math.floor((s % 86400) / 3600)) + ':' + p(Math.floor((s % 3600) / 60)) + ':' + p(s % 60);
    });
  }

  /* ---------------- Saved for later ---------------- */
  const cache = new Map();
  function product(h) {
    const k = 'h:' + h;
    if (!cache.has(k)) cache.set(k, fetch(`${base()}products/${encodeURIComponent(h)}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    return cache.get(k);
  }
  const imgSrc = (p, w) => {
    let i = p.featured_image || '';
    if (i && typeof i === 'object') i = i.src || '';
    if (!i) return '';
    if (i.startsWith('//')) i = 'https:' + i;
    return i + (i.includes('?') ? '&' : '?') + 'width=' + w;
  };
  const sizeLabel = (p, v) => {
    if (!v || (p.variants || []).length < 2) return '';
    return (p.type === 'Shoes' ? 'EU ' : (T.size || 'Size') + ' ') + (v.option1 || v.title);
  };
  let savedToken = 0;
  async function paintSaved() {
    const r = root();
    const sec = r && $('[data-fv-saved]', r);
    if (!sec || r.dataset.saved !== '1') return;
    const list = $('[data-fv-saved-list]', sec);
    const inBag = new Set((r.dataset.handles || '').split(',').filter(Boolean));
    const hs = favs().filter((h) => !inBag.has(h)).reverse().slice(0, 6);
    const token = ++savedToken;
    if (!hs.length) { sec.hidden = true; list.innerHTML = ''; return; }
    const ps = (await Promise.all(hs.map(product))).filter(Boolean);
    if (token !== savedToken || !document.contains(list)) return;
    const map = savedMap();
    list.innerHTML = ps.map((p) => {
      const vs = p.variants || [];
      let v = vs.find((x) => String(x.id) === String(map[p.handle]));
      if (!v && vs.length === 1) v = vs[0];
      const avail = v ? v.available : p.available;
      const price = v ? v.price : p.price;
      const cmp = v ? v.compare_at_price : p.compare_at_price;
      const sale = cmp && cmp > price;
      const pct = sale ? Math.floor(((cmp - price) * 100) / cmp) : 0;
      const url = `${base()}products/${p.handle}`;
      const src = imgSrc(p, 300);
      const tags = (pct ? `<span class="fv-bag-tag fv-bag-tag--sale">−${pct}%</span>` : '') + (!avail ? `<span class="fv-bag-tag fv-bag-tag--quiet">${esc(T.sold)}</span>` : '');
      return `<article class="fv-si" data-handle="${esc(p.handle)}" data-variant="${v ? v.id : ''}">
        <a class="fv-si__im" href="${url}" tabindex="-1" aria-hidden="true">${src ? `<img src="${esc(src)}" alt="" width="96" height="96" loading="lazy">` : ''}</a>
        <div class="fv-si__bd">
          ${p.vendor ? `<span class="fv-si__br">${esc(p.vendor)}</span>` : ''}
          <a class="fv-si__t" href="${url}">${esc(p.title)}</a>
          ${v && sizeLabel(p, v) ? `<span class="fv-si__v">${esc(sizeLabel(p, v))}</span>` : ''}
          <div class="fv-si__tags">${tags}</div>
        </div>
        <div class="fv-si__r">
          <p class="fv-si__p${sale ? ' is-sale' : ''}">${money(price)}${sale ? `<s>${money(cmp)}</s>` : ''}</p>
          <button type="button" class="fv-btn fv-si__go" data-fv-move${avail ? '' : ' disabled'}>${esc(T.move)}</button>
          <button type="button" class="fv-si__x" data-fv-unsave>${esc(T.remove)}</button>
        </div>
        ${!v && vs.length > 1 ? `<div class="fv-si__sz" data-fv-si-sz role="group" aria-label="${esc(T.choose)}" hidden><span>${esc(T.choose)}</span>${vs.map((x) => `<button type="button" data-fv-si-v="${x.id}"${x.available ? '' : ' disabled'}>${p.type === 'Shoes' ? 'EU ' : ''}${esc(x.option1 || x.title)}</button>`).join('')}</div>` : ''}
      </article>`;
    }).join('');
    sec.hidden = !ps.length;
  }

  /* ---------------- Goes with your bag ---------------- */
  let recoMemo = { key: '', html: '' };
  async function sectionHTML(pid, intent) {
    const k = 'r:' + pid + ':' + intent;
    if (!cache.has(k)) {
      cache.set(k, fetch(`${base()}recommendations/products?section_id=fovory-bag-reco&product_id=${pid}&limit=10&intent=${intent}`)
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => ''));
    }
    return cache.get(k);
  }
  async function paintReco() {
    const r = root();
    const sec = r && $('[data-fv-rc]', r);
    if (!sec || r.dataset.reco !== '1') return;
    const box = $('[data-fv-rc-list]', sec);
    const seeds = (r.dataset.seeds || '').split(',').filter(Boolean);
    const key = r.dataset.seeds + '|' + r.dataset.handles;
    if (key === recoMemo.key) { box.innerHTML = recoMemo.html; sec.hidden = !recoMemo.html; return; }
    if (!seeds.length) return;
    let html = '';
    for (const intent of ['complementary', 'related']) {
      const t = await sectionHTML(seeds[0], intent);
      const doc = new DOMParser().parseFromString(t || '', 'text/html');
      const grid = $('[data-fv-rc-grid]', doc);
      if (grid && $('[data-fv-rc-item]', grid)) { html = grid.outerHTML; break; }
    }
    recoMemo = { key, html };
    const cur = $('[data-fv-rc]', root());
    if (!cur) return;
    $('[data-fv-rc-list]', cur).innerHTML = html;
    cur.hidden = !html;
  }

  /* ---------------- Pieces that close the free delivery gap ---------------- */
  // Shopify's own collection filters pick the cheapest available pieces that cost at least what is missing.
  function gapProducts(url, gap) {
    const k = 'g:' + url + ':' + gap;
    if (!cache.has(k)) {
      const q = `${url}${url.includes('?') ? '&' : '?'}filter.v.price.gte=${(gap / 100).toFixed(2)}&filter.v.availability=1&sort_by=price-ascending&section_id=fovory-bag-gap`;
      cache.set(k, fetch(q)
        .then((r) => (r.ok ? r.text() : ''))
        .then((t) => {
          const el = $('[data-fv-gap-json]', new DOMParser().parseFromString(t || '', 'text/html'));
          try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
        })
        .catch(() => []));
    }
    return cache.get(k);
  }
  function gapCard(p) {
    const vs = p.variants || [];
    const avail = vs.filter((v) => v.available);
    const opts = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const mode = vs.length === 1 && avail.length === 1 ? 'one' : opts.length === 1 ? 'size' : 'link';
    const url = `${base()}products/${p.handle}`;
    const src = imgSrc(p, 200);
    const sale = p.compare_at_price && p.compare_at_price > p.price;
    const label = esc(fill(T.add, { t: p.title }));
    const add = mode === 'link'
      ? `<a class="fv-gf__add" href="${url}" aria-label="${label}">${icon.plus}</a>`
      : `<button type="button" class="fv-gf__add" data-fv-gf-add aria-label="${label}"${mode === 'size' ? ' aria-expanded="false"' : ''}>${icon.plus}</button>`;
    const sizes = mode !== 'size' ? '' : `<div class="fv-gf__sz" data-fv-gf-sz role="group" aria-label="${esc(T.choose)}" hidden>${vs.map((x) => `<button type="button" data-fv-gf-v="${x.id}"${x.available ? '' : ' disabled'}>${p.type === 'Shoes' ? 'EU ' : ''}${esc(x.option1 || x.title)}</button>`).join('')}</div>`;
    return `<article class="fv-gf" role="listitem" data-mode="${mode}" data-variant="${mode === 'one' ? avail[0].id : ''}">
      <a class="fv-gf__im" href="${url}" tabindex="-1" aria-hidden="true">${src ? `<img src="${esc(src)}" alt="" width="64" height="64" loading="lazy">` : ''}</a>
      <div class="fv-gf__bd"><a class="fv-gf__t" href="${url}">${esc(p.title)}</a><p class="fv-gf__p${sale ? ' is-sale' : ''}">${money(p.price)}${sale ? `<s>${money(p.compare_at_price)}</s>` : ''}</p></div>
      ${add}
      ${sizes}
    </article>`;
  }
  let gapMemo = { key: '', html: '' };
  async function paintGap() {
    const r = root();
    const box = r && $('[data-fv-gap]', r);
    if (!box) return;
    const gap = parseInt(r.dataset.gap || '0', 10) || 0;
    const key = gap + '|' + r.dataset.handles + '|' + r.dataset.gapUrl;
    if (key === gapMemo.key) { $('[data-fv-gap-list]', box).innerHTML = gapMemo.html; box.hidden = !gapMemo.html; return; }
    if (!gap) return;
    const inBag = new Set((r.dataset.handles || '').split(',').filter(Boolean));
    const all = `${base()}collections/all`;
    const pick = (list) => list.filter((p) => p.price >= gap && !inBag.has(p.handle));
    let ps = pick(await gapProducts(r.dataset.gapUrl || all, gap));
    if (!ps.length && r.dataset.gapUrl && !/\/collections\/all$/.test(r.dataset.gapUrl)) ps = pick(await gapProducts(all, gap));
    const html = ps.slice(0, 3).map(gapCard).join('');
    gapMemo = { key, html };
    const cur = root() && $('[data-fv-gap]', root());
    if (!cur) return;
    $('[data-fv-gap-list]', cur).innerHTML = html;
    cur.hidden = !html;
  }

  /* ---------------- Checkout bar ---------------- */
  let io = null;
  function paintBar() {
    if (io) { io.disconnect(); io = null; }
    const r = root();
    const bar = r && $('[data-fv-bar]', r);
    const go = r && $('[data-fv-go]', r);
    if (!bar || !go || !('IntersectionObserver' in window)) { document.documentElement.classList.remove('fv-bag-bar'); return; }
    const small = window.matchMedia('(max-width: 1023px)');
    const state = { go: false, foot: false };
    const set = () => {
      const on = small.matches && !state.go && !state.foot;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      const b = $('button', bar);
      if (b) b.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('fv-bag-bar', on);
    };
    io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.target === go) state.go = e.isIntersecting;
        else state.foot = e.isIntersecting;
      });
      set();
    });
    io.observe(go);
    const foot = $('.fv-shipto') || $('.fv-site-footer');
    if (foot) io.observe(foot);
    set();
  }

  function paint() {
    readStrings();
    paintUndo();
    tick();
    paintGap();
    paintSaved();
    paintReco();
    paintBar();
  }

  /* ---------------- Actions ---------------- */
  async function change(card, qty) {
    busy(card, true);
    try {
      publish(await post('cart/change.js', { id: card.dataset.key, quantity: qty }));
    } catch (e) {
      busy(card, false);
      toast($('.fv-bi__bd', card), e.message);
    }
  }
  async function addVariant(id, qty, el) {
    busy(el, true);
    try {
      const j = await post('cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] });
      publish(j);
      return true;
    } catch (e) {
      busy(el, false);
      toast(el, e.message);
      return false;
    }
  }
  async function swapSize(card, newId) {
    if (String(newId) === card.dataset.variant) return;
    busy(card, true);
    try {
      await post('cart/add.js', { items: [{ id: Number(newId), quantity: Number(card.dataset.qty) || 1 }] });
      publish(await post('cart/change.js', { id: card.dataset.key, quantity: 0 }));
    } catch (e) {
      busy(card, false);
      toast($('.fv-bi__bd', card), e.message);
    }
  }
  async function applyCode(code) {
    const box = $('[data-fv-code]', root());
    const err = box && $('[data-fv-code-err]', box);
    if (err) err.hidden = true;
    try {
      const j = await post('cart/update.js', { discount: code });
      if (!Array.isArray(j.discount_codes)) {
        // Older storefronts: the discount URL applies the code and comes back here.
        location.href = `${base()}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname)}`;
        return;
      }
      const hit = j.discount_codes.find((d) => String(d.code).toLowerCase() === code.toLowerCase());
      if (code && hit && hit.applicable === false) {
        publish(await post('cart/update.js', { discount: '' }));
        const b2 = $('[data-fv-code]', root());
        if (b2) {
          b2.classList.add('is-open');
          const e2 = $('[data-fv-code-err]', b2);
          if (e2) { e2.textContent = T.codeBad; e2.hidden = false; }
          const i2 = $('[data-fv-code-in]', b2);
          if (i2) { i2.value = code; i2.focus(); }
        }
        return;
      }
      publish(j);
    } catch (e) {
      if (err) { err.textContent = e.message || T.error; err.hidden = false; }
    }
  }

  function onClick(e) {
    const r = root();
    if (!r || !r.contains(e.target)) return;
    const card = e.target.closest('.fv-bi');
    const q = e.target.closest('[data-fv-q]');
    if (q && card) { undo = null; change(card, Math.max(0, parseInt(q.dataset.fvQ, 10) || 0)); return; }
    if (e.target.closest('[data-fv-rm]') && card) {
      undo = { kind: 'removed', t: Date.now(), title: card.dataset.title, variant: card.dataset.variant, qty: Number(card.dataset.qty) || 1, index: $$('.fv-bi', r).indexOf(card) };
      change(card, 0);
      return;
    }
    if (e.target.closest('[data-fv-later]') && card) {
      const h = card.dataset.handle;
      const wasFav = favs().includes(h);
      addFav(h);
      setSaved(h, card.dataset.variant);
      undo = { kind: 'saved', t: Date.now(), title: card.dataset.title, variant: card.dataset.variant, qty: Number(card.dataset.qty) || 1, index: $$('.fv-bi', r).indexOf(card), handle: h, addedFav: !wasFav };
      change(card, 0);
      return;
    }
    const ch = e.target.closest('[data-fv-change]');
    if (ch && card) {
      const sz = $('.fv-bi__sz', card);
      const open = sz.hidden;
      sz.hidden = !open;
      ch.setAttribute('aria-expanded', String(open));
      if (open) { const cur = $('[aria-pressed="true"]', sz) || $('button:not([disabled])', sz); if (cur) cur.focus(); }
      return;
    }
    const size = e.target.closest('[data-fv-size]');
    if (size && card) { undo = null; swapSize(card, size.dataset.fvSize); return; }
    if (e.target.closest('[data-fv-undo]') && undo) {
      const u = undo;
      undo = null;
      if (u.kind === 'saved') { setSaved(u.handle, null); if (u.addedFav) removeFav(u.handle); }
      addVariant(u.variant, u.qty, e.target.closest('.fv-bi-undo'));
      return;
    }
    const gf = e.target.closest('.fv-gf');
    if (gf && e.target.closest('[data-fv-gf-add]')) {
      undo = null;
      if (gf.dataset.mode === 'one') { addVariant(gf.dataset.variant, 1, gf); return; }
      const sz = $('[data-fv-gf-sz]', gf);
      const btn = $('[data-fv-gf-add]', gf);
      if (sz) {
        const open = sz.hidden;
        sz.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) { const b = $('button:not([disabled])', sz); if (b) b.focus(); }
      }
      return;
    }
    const gfv = e.target.closest('[data-fv-gf-v]');
    if (gf && gfv) { undo = null; addVariant(gfv.dataset.fvGfV, 1, gf); return; }
    const si = e.target.closest('.fv-si');
    if (si && e.target.closest('[data-fv-move]')) {
      undo = null;
      if (si.dataset.variant) addVariant(si.dataset.variant, 1, si).then((ok) => { if (ok) setSaved(si.dataset.handle, null); });
      else { const sz = $('[data-fv-si-sz]', si); if (sz) { sz.hidden = false; const b = $('button:not([disabled])', sz); if (b) b.focus(); } }
      return;
    }
    const siv = e.target.closest('[data-fv-si-v]');
    if (si && siv) { undo = null; addVariant(siv.dataset.fvSiV, 1, si).then((ok) => { if (ok) setSaved(si.dataset.handle, null); }); return; }
    if (si && e.target.closest('[data-fv-unsave]')) {
      removeFav(si.dataset.handle);
      setSaved(si.dataset.handle, null);
      paintSaved();
      return;
    }
    if (e.target.closest('[data-fv-code-open]')) {
      const box = e.target.closest('[data-fv-code]');
      box.classList.add('is-open');
      e.target.closest('[data-fv-code-open]').setAttribute('aria-expanded', 'true');
      const i = $('[data-fv-code-in]', box);
      if (i) i.focus();
      return;
    }
    if (e.target.closest('[data-fv-code-apply]')) {
      const i = $('[data-fv-code-in]', root());
      const code = i ? i.value.trim() : '';
      if (code) applyCode(code);
      return;
    }
    if (e.target.closest('[data-fv-code-rm]')) { applyCode(''); }
  }
  function onKey(e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-fv-code-in]')) {
      e.preventDefault();
      const code = e.target.value.trim();
      if (code) applyCode(code);
    }
  }

  function hook(tries = 0) {
    if (!window.MinimogEvents || !window.MinimogTheme) {
      if (tries < 50) setTimeout(() => hook(tries + 1), 200);
      return;
    }
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (e) => {
      const c = e && e.cart;
      if (c && c.sections && c.sections[sid()]) render(c.sections[sid()]);
    });
  }

  function init() {
    if (!root()) return;
    document.addEventListener('cart:grouped-sections', (e) => {
      const id = sid();
      if (id && e.detail && Array.isArray(e.detail.sections) && !e.detail.sections.includes(id)) e.detail.sections.push(id);
    });
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    window.addEventListener('pageshow', (e) => { if (e.persisted) location.reload(); });
    hook();
    paint();
    setInterval(tick, 1000);
    window.FovoryBag = { paint, render };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
